/**
 * Shared Google Fonts list and stylesheet injector.
 * Keeps font availability consistent across canvas renders and UI pickers.
 */

export const GOOGLE_FONTS = [
  'Arial', 'Inter', 'Roboto', 'Open Sans', 'Lato',
  'Montserrat', 'Oswald', 'Poppins', 'Nunito',
  'Playfair Display', 'Merriweather', 'Ubuntu',
  'Cinzel', 'Bebas Neue', 'Lobster', 'Pacifico'
];

let googleFontsReadyPromise = null;

export const ensureGoogleFontsStylesheet = () => {
  if (typeof document === 'undefined') return Promise.resolve();
  if (googleFontsReadyPromise) return googleFontsReadyPromise;

  const linkId = 'ag-google-fonts';
  let link = document.getElementById(linkId);
  if (!link) {
    link = document.createElement('link');
    link.id = linkId;
    const families = GOOGLE_FONTS.filter(f => f !== 'Arial').map(f => f.replace(/ /g, '+'));
    link.href = `https://fonts.googleapis.com/css2?family=${families.join('&family=')}&display=swap`;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }

  googleFontsReadyPromise = new Promise((resolve) => {
    let resolved = false;
    const resolveOnce = () => {
      if (resolved) return;
      resolved = true;
      link.dataset.agLoaded = 'true';
      resolve();
    };

    if (link.dataset.agLoaded === 'true' || link.sheet) {
      resolveOnce();
      return;
    }

    const onLoad = () => {
      cleanup();
      resolveOnce();
    };
    const onError = () => {
      cleanup();
      resolveOnce();
    };
    const cleanup = () => {
      link.removeEventListener('load', onLoad);
      link.removeEventListener('error', onError);
    };

    link.addEventListener('load', onLoad);
    link.addEventListener('error', onError);

    // Fallback in case the load event already fired before we attached.
    setTimeout(resolveOnce, 3000);
  });

  return googleFontsReadyPromise;
};
